import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectedCompanyStepAction } from "../../../actions/company";
import { useForm } from "react-hook-form";
import { addCompanyPublicAction } from "../../../actions/auth";
import { useNavigate } from "react-router";
import { RoutesPaths } from "../../../Router/constant";
import { getAuthorisationCallPublicAction } from "../../../actions/myinfo";


export default function AddEmail() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});
  const { businessData } = useSelector((state) => state.company);
  const [loader, setLoader] = useState(false)
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const stepBack = () => {
    dispatch(selectedCompanyStepAction(4))
  };

  const onSubmit = async (data) => {
    setLoader(true);
    let allData = { ...businessData, ...data };
    if (allData.verificationMethod === "myinfo") {
      var resp = await dispatch(addCompanyPublicAction({ ...allData, isActive: false, }))
      if (resp) {
        const authoriseUrl = await dispatch(getAuthorisationCallPublicAction(resp?.id));
        if (authoriseUrl && authoriseUrl.status && authoriseUrl.data) {
          setTimeout(() => {
            window.location = authoriseUrl.data;
          }, 1000);
          setLoader(false)
        }
      }
    } else {
      var resp = await dispatch(addCompanyPublicAction({ ...allData, isActive: true, }))
      if (resp?.chat) {
        navigate(RoutesPaths.MESSAGE_DETAIL_PUBLIC + "?room=" + resp.chat + "&ispublic=true", {replace: true});
      }
      setLoader(false)
      reset();
    }
  };
  return (
    <>
      <div className="row right-side-row landingPage">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xl-12 verifyForm">
          <p>Enter your Name and email</p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group ">
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      maxLength={50}
                      autoComplete="nope"
                      type="text"
                      className="form-control"
                      placeholder="First name"
                      {...register("first_name", {
                        required: true,
                        maxLength: 20,
                        minLength: 3,
                      })}
                    />
                    {errors.first_name?.type === "required" && (
                      <span className="errorMessage">
                        First name is required
                      </span>
                    )}
                    {errors.first_name?.type === "maxLength" && (
                      <span className="errorMessage">
                        First name may not be longer than 20 characters
                      </span>
                    )}
                    {errors.first_name?.type === "minLength" && (
                      <span className="errorMessage">
                        Minimum 3 characters required
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      maxLength={50}
                      autoComplete="nope"
                      type="text"
                      className="form-control"
                      placeholder="Last name"
                      {...register("last_name", { required: true })}
                    />
                    {errors.last_name?.type === "required" && (
                      <span className="errorMessage">
                        Last name is required
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <input
                  maxLength={50}
                  autoComplete="nope"
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  {...register("email", {
                    required: true,
                    pattern:
                      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
                  })}
                />
                {errors.email?.type === "required" && (
                  <span className="errorMessage">
                    Email is required
                  </span>
                )}
                {errors.email?.type === "pattern" && (
                  <span className="errorMessage">Email is invalid</span>
                )}
              </div>
            </div>
            <div className="modal-footer modal-bottom-action">
              <button
                type="button"
                onClick={stepBack}
                className={`btn btn-sm  mb-4 mt-3 contactus-modal-button`}
              >
                Go back
              </button>
              <button type="submit" disabled={loader} className="btn agree-button">
                {loader && <i className="animateSpin fa-solid fa-circle-notch"></i>}
                Save and Proceed
                <img src="assets/img/nextStep.svg" alt="" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
